import { FC } from "react"
import { Styled } from "./styled"
import { Cascader } from "antd"
import { ItemCascaderProps } from "./models"
import { DefaultOptionType } from "antd/lib/cascader"

const { SHOW_CHILD } = Cascader
const { StyledFormItem } = Styled

export const ItemCascader: FC<ItemCascaderProps> = ({
  isBgBlue,
  isDisabled,
  label,
  name,
  onChange,
  onClear,
  options,
  required,
  rules,
  tooltip,
  ...res
}) => (
  <StyledFormItem
    extra={
      <span aria-hidden="true" className="ant-select-arrow">
        <span
          aria-label="down"
          className="anticon anticon-down ant-select-suffix"
          role="img"
        >
          <svg
            aria-hidden="true"
            data-icon="down"
            fill="currentColor"
            focusable="false"
            height="1em"
            viewBox="64 64 896 896"
            width="1em"
          >
            <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
          </svg>
        </span>
      </span>
    }
    isBgBlue={isBgBlue}
    label={label}
    name={name}
    required={required}
    rules={rules}
    tooltip={tooltip}
    {...res}
  >
    <Cascader
      disabled={isDisabled}
      maxTagCount="responsive"
      multiple
      onChange={onChange}
      onClear={onClear}
      options={options}
      showCheckedStrategy={SHOW_CHILD}
      showSearch={{
        filter: (inputValue: string, path: DefaultOptionType[]) =>
          path.some((option) =>
            (option.label as string)
              .toLowerCase()
              .includes(inputValue.toLowerCase()),
          ),
      }}
    />
  </StyledFormItem>
)
